import React, { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify';
import { admissionsService } from '@/services/admissionsService';
import { ApplicationStatus } from '@/models/application.model';

interface Props {
  isOpen: boolean
  onClose: () => void
  applicationId: string
  currentStatus: string
}

export const ApplicationStatusModal: React.FC<Props> = ({
  isOpen,
  onClose,
  applicationId,
  currentStatus,
}) => {
  const queryClient = useQueryClient()
  const [status, setStatus] = useState(currentStatus)
  const [note, setNote] = useState('')

  const mutation = useMutation({
    mutationFn: () =>
      admissionsService.updateApplicationStatus(applicationId, status, note),
    onSuccess: (res) => {
      toast.success(res.message)
      queryClient.invalidateQueries({ queryKey: ['application', applicationId] })
      onClose()
    },
    onError: (err: any) => {
      toast.error(err.message || 'Failed to update status')
    },
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Update Application Status" size="sm">
      <div className="space-y-4">
        <select
          className="w-full border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#7b2a40]"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">Select status</option>
          {Object.values(ApplicationStatus).map((s) => (
            <option key={s} value={s}>
              {s.replace('_', ' ')}
            </option>
          ))}
        </select>

        <textarea
          placeholder="Add a note (optional)"
          className="w-full border rounded-md px-3 py-2 text-sm min-h-[80px] focus:ring-2 focus:ring-[#7b2a40]"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <button
          onClick={() => mutation.mutate()}
          disabled={mutation.isPending}
          className="w-full bg-[#7b2a40] text-white py-2 rounded-md text-sm font-medium hover:bg-[#682133] transition disabled:opacity-70"
        >
          {mutation.isPending ? 'Updating...' : 'Update Status'}
        </button>
      </div>
    </Modal>
  )
}
